export const PAGE_NAME = 'gig_page';
export const SINGLE_PACKAGE = 'single';
export const TRIPLE_PACKAGE = 'triple';
export const GIG_GALLERY = 'gig_gallery';
export const GIG_SUB_HEADER = 'gig_sub_header';
export const GIG_NAV_MENU = 'gig_navigation_menu';
export const YOUR_RECENTLY_VIEWED_GIGS = 'your_recently_viewed_gigs';
export const RECOMMENDED_IN_SC = 'recommended_in_sc';
export const RECOMMENDED_IN_PRO_SC = 'recommended_in_pro_sc';
export const OTHER_GIGS_BY = 'other_gigs_by';
export const SIMILAR_GIGS = 'similar_gigs';
